import React from 'react'
import './blogs.css'
const Aryaman_Shandilya = () => {
    return (
        <div className='blog'>
            <div className='container-fluid'>
                <div className='row blog-row'>
                    <div className='col-md-4'>
                        <img src='placement-postulates/blogs/Aryaman-Shandilya/1.jpg' className='blog-dp' alt='aryaman'></img>
                    </div>
                    <div className='col-md-8'>
                        <div className='blog-head'>
                            <h2>Aryaman Shandilya</h2>
                            <small>Associate
        Product Manager, Zomato.</small>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className='row'>
                        <div>
                        <p>Hey everyone, I am Aryaman Shandilya. I am a Y18 BT/CE student, and I am currently working as an Associate
        Product Manager at Zomato. Through this piece, I will try my best to help you prepare for your placements. While
        this may apply more to some than others, I hope every one who is taking the time out to read this is able to
        take something out of this.
      </p>
      <b>My preparation for placements :</b>
      <p>
        Disclaimer: Any readers must understand that I did not have any particularly strong interests while going
        through the process. I do not dislike writing code, nor do I have a particular affinity towards it. I could see
        myself doing well in a Product role, but wouldn’t have been disappointed if I went elsewhere. I am writing this
        from a neutral standpoint, and if you have a strong interest towards a particular role, by all means go out and
        get it.
      </p>
      <p> 
        In line with that, one thing I made sure was to not limit my prep to a particular role, and keep my options open
        until the end because the whole placement drive is a very dynamic process, and more often than not you end up
        some place where you didn’t think you would. The reasoning is quite straightforward, let’s say you’re targeting
        a Data Science role. Most data science roles had their interviews scheduled on Day 2 Slot 1. Now, if you get an
        interview call for a product role, most likely in Day 1 Slot 2, you will end up being underprepared for the
        opportunity if you limit yourself to a particular role during prep.
      </p>
      <p> <img class="blog-image-left" src="placement-postulates/blogs/Aryaman-Shandilya/2.jpg"/>
        To start, I would recommend covering all the bases. This mostly includes two parts Aptitude, and Coding. Now
        some companies ask for a little more with case studies, english tests, and even core CS, but that is all
        secondary.
      </p>
      <p>
        Aptitude generally consists of math and logical reasoning. The focus is usually on speed rather than difficult
        concepts. And that is one thing to remember while giving the tests, if a question doesn’t strike you the first
        time you read it, move on and come back to it if there is time. You must, however, make sure that you have all
        your bases covered. Some people are inherently faster than others, but you have to work with yourself only and
        the only way to make yourself quicker is through practice. Aptitude questions mostly come from a definitive set
        of types of questions. If your prep is strong enough, more often that not you will have solved some variation of
        every question that comes your way. One most important thing is to learn while giving your tests. If you
        encounter a question you weren’t able to do in the given time limit, sit with it afterwards. Develop your own
        tricks to solve all kinds of questions, and this way you should be alright. As far as prep resources go, a bulk
        of my prep for aptitude came from Prepleaf. Apart from that, I brushed up on Probability and Statistics from my
        HSO201 notes.
      </p>
      <p>
      <img class="blog-image-right" src="placement-postulates/blogs/Aryaman-Shandilya/3.jpg"/>
      Next in line is coding. For coding, again, it is all about pattern recognition. The problems and time limits are
      designed in a way that you will be able to do them comfortably if you have a good grip on your concepts, and are
      able to recognise what the problem demands in the first few minutes. Once you practice enough questions you will
      surely start to see a pattern forming in questions that use the same concept. For example, if you see that there
      is a logN term in the required time complexity, more often than not, it will be a Divide and Conquer type of
      problem. The best tip, again, is to cover all bases concept wise and practice as much as possible. The resources I
      used were my ESO207 (Data Structures and Algorithms) notes for concepts, I did questions from InterviewBit and
      Leetcode for practice. And then further, went through the first 8 sections in the problems in cracking the coding
      interview.
      </p>
      <p>
        <b>When should you start preparing?</b>
        <br/>
        Specifically for placements, I started preparing in July/August, which I feel is late. Around mid-September,
        tests start, and mid-sem exams also begin. You get very little time to prep—your prep halts around the end of
        September. So you should begin coding during the summers. Ideally, the 6th sem is best to start and start
        building a base and clearing concept because you won’t be able to devote much time in the summers due to
        internships or projects. Daily 1 or 1.5 hrs is more than enough; but make sure you are regular
        <br/>

        Build a strong group of 2-3 friends, this will keep you in check, and there will be also a healthy competitive
        environment. Your prep will get compounded since you will learn what they have learnt as well. Make sure you
        have a good circle of friends aiming for the same thing around you.
      </p>
      <p><img class="blog-image-left" src="placement-postulates/blogs/Aryaman-Shandilya/5.jpg"/>
        There are three roles :
      </p>
      <p>
        Software: Coding/Aptitude
      </p>
      <p>
        In coding, most companies give the problems in JAVA, so I suggest you do coding in C++ and at least prepare for
        the basic understanding of JAVA. C++ is the safest option. They don’t check how many languages you know; they
        check for your logic base. Few companies may ask for DBMS and OS (go for it only if you have prepared for
        everything; otherwise not worth it).

      </p>
      <p>Core :</p>
      <p>
        I didn’t apply for any core companies. Most core companies come on day four and day five. Usually, they like to
        pick up postgrads. I recommend that if you are applying for core, you should go for masters. In Civil
        engineering, experience and core knowledge takes priority over aptitude and sharpness. More often than not,
        undergraduate students lack the experience or knowledge to thrive in these fields. I wouldn’t hire my own self
        because my batch espcially does not have enough practical experience for an on-site position. Masters is a
        better option; after that, you can explore many sub-divisions like transport, traffic simulation, etc.
      </p>

      <b>MY INTERVIEW DURING PLACEMENT SEASON</b>
      <p><i>
          I will speak about two interviews, my first rejection, and then the company that I eventually went for.
        </i>
      <p> Date: 1st December 2021</p>
      <p>Day 1(Slot 1)</p>
      <p>Time: 12 AM to 8 AM</p>
      <p>Shortlisted Company: Goldman Sachs: ( 3 round)</p>
      <p>My first interview was at 2 AM, where the interviewer asked two fairly common coding questions. The interviewer
        gave me a good review in this round, and pointed out that he liked the fact that I talked through the process
        because it gave them a better understanding of my train of thought.</p>
      <p>
        In the 2nd round, the same thing happened, but the feedback was different, fair enough for a different
        interviewer. In this round, they told me that I was talking too much. However, I was told to wait as I had been
        moved to the third round,
      </p>
      My 3rd round did not happen due to time constraints, and I got rejected. This was the HR round. All students that
      had this round eventually got placed at Goldman Sachs. I could conjure up a number of reasons as to why I got
      rejected, but the truth of the matter that you need to understand at that point in the process is that you have to
      move on and be prepared for the next interview, because no one will wait for you to recuperate.
      </p>
      <p>The entire placement drive is an exercise in rigour and patience, and the interviews, even more so. There is a
        high likelihood that the first interview that you give is not the one where you end up. I cannot stress on the
        importance of not letting a rejection affect you, keeping your chin up and moving on.
      </p>
      <p>It is understandable very difficult and many people, including myself, suffer as emotions run wild and
        everything around you moves really fast, but it is extremely important to keep a level head in these situations.
      </p>
      <p>Day 1 (Slot 2)</p>
      <p>Shortlisted Company: Zomato, Awareness, and Flipkart </p>
      <p>Time: 12 PM onwards</p>
      <p>Zomato APM: Single round</p>
      <img class="blog-image-right" src="placement-postulates/blogs/Aryaman-Shandilya/6.jpg"/>
      <p>The interview started at 12 PM and was 40 minutes long. To start off, the interviewer asked me to introduce
        myself and asked whether I would like to proceed with the interview for an APM or a Product Analyst. It must be
        noted that Zomato had a common test for both roles and a common shortlist was made with interviewees then being
        asked to chose. Then, the interviewers asked me what my favourite product was. One that must be noted at this
        point is that I had not specifically prepared for product roles. The only APM role that I even applied to was
        Zomato because every other company required a deck and I felt like making a deck for a company which will then
        only get you shortlisted for an interview is not a great cost-benefit proposition. Most people would have this
        answer prepared, but I did not. So I ended up naming what actually was my favourite product and not just
        something I prepared for. NOw, while I would highly recommend being prepared for this question and other things
        that are commonly asked in APM interviews, I would also like to say that it is important that you actually pick
        a product that you genuinely like. Because in a lot of cases the questions you are asked will deviate from your
        prep, and you must not blank out if such a situation occurs. This is why I would recommend picking a product
        that you know and use regularly so that if such a situation occurs, you can answer what is in front of you.
        Another tip is to be quick on your feet, take pauses, ask for time to think and come up with a solid answer that
        you can defend. I was asked questions about my Chess.com’s business model, their revenue streams, competitions,
        pitfalls, etc. I was comfortable answering those questions because I honestly described my favourite product,
        which is something I go on overy day. My interview experience was excellent, and I was pretty sure I would be
        selected. Towards the end, I did have an informal chit chat with my interviewer and overall, I felt at ease.</p>
      <img class="blog-image-left" src="placement-postulates/blogs/Aryaman-Shandilya/4.jpg"/>
      <p>I am extremely thankful to my wingies Daksh, Akarsh, Harsh, Nirmal, Mahesh, Mudit, Apoorv, and Lakshay who
        helped me prepare for this placement season. At the time of the interviews, everyone is willing to help
        everyone, I made really strong friendships with a lot of people that I still meet almost everyday even today
        outside of college. You can’t sleep properly until all your friends get jobs. That’s how it was for us and for
        most other people. </p>
      <p>
        Key points which must be kept in mind during the interview:
      </p>
      <ol>
        <li>Interviewers respect how you reach the solution rather than how quickly you answer. If you know the answer,
          they move on to the next question. They keep asking questions until you take enough time to think over a
          problem and conclude. They want to check your thought process.
        </li>
        <li>If possible, it is beneficial to give an interview at the beginning of the slot. Interviewers are relaxed at
          the start of the interview, keep enjoying and asking good questions but get tired and disinterested by the end
          of the slot.
        </li>
        <li>
          In the interview preparation, theoretical and technical preparation are the aspects that everybody knows but
          how to give an interview is a completely different game. This creates a huge difference. Generally, students
          don’t focus on this skill, which is very important.

        </li>
        <li>
          Interviewers check your communication skills, problem-solving approach, and how you accept the challenges
          throughout the interview. If you don’t know the answers, take 2 or 3 minutes, think about the problems, and
          stay on the right track but don’t give an answer you cannot defend. They also check how accountable you are
          for your work.

        </li>
        <li>
          It happens in the interview that you learn new things about yourself. Your introduction grows in each
          interview successively. You think everyone has given such a basic introduction, what unique things to be
          added, and you tried to add bits and pieces. You need not prepare everything you will say during the
          interview. But make sure you are prepared to be able to think clearly and say what you need to during the
          interview.

        </li>
        <li>
          Give a simple and original answer to which you are closely connected and understandable to the interviewers.
          You don;t need to give scripted detailed solutions. It can sometimes create problems during the interview,
          because either the interviewer knows your source and finds out it is scripted or they are not able to
          understand what you are saying. Always maintain your originality towards answering the questions and develop
          your methodology rather than end products.

        </li>
        <li>
          The placement drive takes a heavy toll on your mental health. Every test, every shortlist, every interview, it
          just keeps on mounting the pressure on you so it is very important to keep yourself grounded, level-headed and
          focussed throughout the process. If you make sure that happens, you will be rewarded.

        </li>
        <li>
          If possible, try to end your interview on a slightly lighter note, at the end of the day interviewers are
          human as well, and appealing to their human side cannot hurt your chances.

        </li>
        <li>
          At the end of the day, if you are like me, you will be playing the percentage game. Do whatever you think
          improves your chances of getting where you want, and if there’s something else that does the same in less time
          and effort, do that first.
        </li>
      </ol>
      <p>
        Cheers, everyone! I wish you all the very best for the challenges that lie in front of you and hope to see some
        of you at the Zomato office in a year or two.

      </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aryaman_Shandilya